import {clientsClaim as workbox_core_clientsClaim} from '/opt/atlassian/pipelines/agent/build/wp-content/themes/pe-morrenhof-jansen-2024/library/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/opt/atlassian/pipelines/agent/build/wp-content/themes/pe-morrenhof-jansen-2024/library/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "library/build/appimg/icons.a921c9b5.svg",
    "revision": "7483baea6d3102f23f583f1d4f00f99f"
  },
  {
    "url": "library/build/appmain.016b40eb.css",
    "revision": null
  },
  {
    "url": "library/build/appmain.dc1a7985.js",
    "revision": null
  },
  {
    "url": "library/build/appmain.dc1a7985.js.LICENSE.txt",
    "revision": "d59d9b5d43b6905d3b20c6da78d7dd72"
  }
], {});








